import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StringHelper {
    public toLowerCamel(word: string, removeEmpty?: boolean): string {
        if (word?.length) {
            if (removeEmpty) {
                word = word.replace(/\s/g, '');
            }
            return `${word[0].toLowerCase()}${word.slice(1)}`;
        }

        return word;
    }
}
